"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const d3_format_1 = require("d3-format");
const vega_embed_1 = __importDefault(require("vega-embed"));
const dom_1 = require("../util/dom");
const math_1 = require("../util/math");
const table_1 = require("./table");
const defaultOpts = {
    maxBins: 12,
    fontSize: 11,
};
function histogram(container, data, opts = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const values = prepareData(data);
        const options = Object.assign({}, defaultOpts, opts);
        const embedOpts = {
            actions: false,
            mode: 'vega-lite',
            defaultStyle: false,
        };
        const histogramContainer = dom_1.subSurface(container, 'histogram');
        if (opts.stats !== false) {
            const statsContainer = dom_1.subSurface(container, 'stats', {
                prepend: true,
            });
            let stats;
            if (opts.stats) {
                stats = opts.stats;
            }
            else {
                stats = math_1.arrayStats(values.map(x => x.value));
            }
            renderStats(stats, statsContainer, { fontSize: options.fontSize });
        }
        const filtered = [];
        for (let i = 0; i < values.length; i++) {
            const val = values[i].value;
            if (val != null && isFinite(val)) {
                filtered.push(values[i]);
            }
        }
        const histogramSpec = {
            'width': options.width || histogramContainer.clientWidth,
            'height': options.height || histogramContainer.clientHeight,
            'padding': 0,
            'autosize': {
                'type': 'fit',
                'contains': 'padding',
                'resize': true,
            },
            'data': { 'values': filtered },
            'mark': 'bar',
            'config': {
                'axis': {
                    'labelFontSize': options.fontSize,
                    'titleFontSize': options.fontSize,
                },
                'text': { 'fontSize': options.fontSize },
                'legend': {
                    'labelFontSize': options.fontSize,
                    'titleFontSize': options.fontSize,
                }
            },
            'encoding': {
                'x': {
                    'bin': { 'maxbins': options.maxBins },
                    'field': 'value',
                    'type': 'quantitative',
                },
                'y': {
                    'aggregate': 'count',
                    'type': 'quantitative',
                },
                'color': {
                    'value': '#001B44',
                }
            }
        };
        return vega_embed_1.default(histogramContainer, histogramSpec, embedOpts);
    });
}
exports.histogram = histogram;
function renderStats(stats, container, opts) {
    const format = d3_format_1.format(',.4~f');
    const pctFormat = d3_format_1.format('.4~p');
    const headers = [];
    const vals = [];
    if (stats.numVals != null) {
        headers.push('Num Vals');
        vals.push(format(stats.numVals));
    }
    if (stats.min != null) {
        headers.push('Min');
        vals.push(format(stats.min));
    }
    if (stats.max != null) {
        headers.push('Max');
        vals.push(format(stats.max));
    }
    if (stats.numZeros != null) {
        headers.push('# Zeros');
        let zeroPct = '';
        if (stats.numVals) {
            zeroPct = stats.numZeros > 0 ?
                `(${pctFormat(stats.numZeros / stats.numVals)})` :
                '';
        }
        vals.push(`${format(stats.numZeros)} ${zeroPct}`);
    }
    if (stats.numNans != null) {
        headers.push('# NaNs');
        let nanPct = '';
        if (stats.numVals) {
            nanPct = stats.numNans > 0 ?
                `(${pctFormat(stats.numNans / stats.numVals)})` :
                '';
        }
        vals.push(`${format(stats.numNans)} ${nanPct}`);
    }
    if (stats.numInfs != null) {
        headers.push('# Infinity');
        let infPct = '';
        if (stats.numVals) {
            infPct = stats.numInfs > 0 ?
                `(${pctFormat(stats.numInfs / stats.numVals)})` :
                '';
        }
        vals.push(`${format(stats.numInfs)} ${infPct}`);
    }
    table_1.table(container, { headers, values: [vals] }, opts);
}
function prepareData(data) {
    if (data.length == null) {
        throw new Error('input data must be an array');
    }
    if (data.length === 0) {
        return [];
    }
    else if (typeof data[0] === 'object') {
        if (data[0].value == null) {
            throw new Error('input data must have a value field');
        }
        else {
            return data;
        }
    }
    else {
        const ret = Array(data.length);
        for (let i = 0; i < data.length; i++) {
            ret[i] = { value: data[i] };
        }
        return ret;
    }
}
//# sourceMappingURL=histogram.js.map